// @ts-nocheck

import { selectRuntimeLicence } from '../../../selectors/runtime/runtimePrimary.selector';
import { selectUserPromotionStatus } from '../../../selectors/user/userPrimary.selector';
import { type StateType } from '../../../states';
import { PromotionStatuses } from '../../../types/promotions';
import { type Selector } from '../../../types/selectors';
import { BoomAllowedLicences, BoomVersion } from '../constants/runtime';
import { BoomGlobalStatuses, BoomSkinIds } from '../types/global';
import { BoomUserStatuses } from '../types/user';

import {
  selectBoomGlobalSkinId,
  selectBoomGlobalStatus,
  selectBoomGlobalVersion,
} from './global/globalPrimary.selector';
import { selectBoomUserStatus } from './user/userPrimary.selector';

export const selectIsBoomEnabled: Selector<boolean> = (state: StateType) => {
  const licence = selectRuntimeLicence(state);
  const userStatus = selectBoomUserStatus(state);
  const version = selectBoomGlobalVersion(state);
  const globalStatus = selectBoomGlobalStatus(state);
  const skinId = selectBoomGlobalSkinId(state);
  const promotionStatus = selectUserPromotionStatus(state);

  return (
    (globalStatus === BoomGlobalStatuses.RUNNING || globalStatus === BoomGlobalStatuses.ENDING) &&
    version === BoomVersion &&
    BoomAllowedLicences.includes(licence) &&
    userStatus !== BoomUserStatuses.EXCLUDED &&
    promotionStatus === PromotionStatuses.DEFAULT &&
    Object.keys(BoomSkinIds).includes(skinId)
  );
};

export const selectIsBoomVisible: Selector<boolean> = (state: StateType) => {
  const isBoomEnabled = selectIsBoomEnabled(state);
  const globalStatus = selectBoomGlobalStatus(state);
  const userStatus = selectBoomUserStatus(state);

  return isBoomEnabled && (userStatus === BoomUserStatuses.IN || globalStatus === BoomGlobalStatuses.RUNNING);
};

export const selectIsBoomPlayable: Selector<boolean> = (state: StateType) => {
  const isBoomEnabled = selectIsBoomEnabled(state);
  const globalStatus = selectBoomGlobalStatus(state);

  return globalStatus === BoomGlobalStatuses.RUNNING && isBoomEnabled;
};
